import { HTMLProps, memo } from 'react';
import { css, Theme } from '@emotion/react';
import { transparentize } from 'polished';

const shadeStyle = (theme: Theme) => css`
  position: relative;

  &::after {
    content: '';
    position: absolute;
    display: block;
    top: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(${transparentize(1, theme.color.background)} 0%, ${theme.color.background} 80%);
  }
`;

export const Shade = memo<HTMLProps<HTMLDivElement>>(
  ({ children, ...props }) => (
    <div {...props} css={shadeStyle}>
      {children}
    </div>
  ),
  () => true
);
